import React from 'react';
import { ButtonStyled } from '@nike/nike-design-system-components';

import { bool, func } from 'prop-types';
import Modal from '../../../../src/modal/Modal';

const BulkDeleteModal = ({ isOpen, closeModal, triggerDelete }) => {
  const footer = ({ isLoading, toggleIsLoading }) => {
    const handleDelete = async () => {
      toggleIsLoading('Deleting...');
      await triggerDelete();

      toggleIsLoading();
      closeModal();
    };

    return (
      <>
        <ButtonStyled
          type='button'
          appearance='primary'
          background='light'
          size='small'
          className='responsive-button'
          onClick={handleDelete}
          disabled={isLoading}
        >
          Delete
        </ButtonStyled>
        <ButtonStyled
          type='button'
          appearance='secondary'
          background='light'
          size='small'
          className='responsive-button'
          onClick={closeModal}
          disabled={isLoading}
        >
          Cancel
        </ButtonStyled>
      </>
    );
  };

  return (
    <Modal
      content={() => 'These product codes will be deleted from all associated catalogs, would you like to proceed?'}
      footer={footer}
      isOpen={isOpen}
      closeModal={closeModal}
    />
  );
};

BulkDeleteModal.propTypes = {
  triggerDelete: func.isRequired,
  closeModal: func.isRequired,
  isOpen: bool.isRequired
};

export default BulkDeleteModal;
